
export default {
  name: 'BaseIcon',
  props: {
    name: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'white',
    },
  },
  computed: {
    realName() {
      return this.name.split(' ')
    },
  },
}
